__turbopack_context__.v({
  "root": "dZxkZW_root",
  "shippingLabelFadeIn": "dZxkZW_shippingLabelFadeIn",
});
